<template>
  <div class="cart-box">
    <div class="cart">
      <div class="cart_head">
        <span class="title">我的投递箱</span>

        <ghidri-back />
      </div>

      <div>
        <el-checkbox-group class="cart-post" v-model="checkedCartItem" v-if="isLogin && cartList.length>0" @change="checkedCartChangeEvent">
          <div v-for="item in cartList" :key="item.id" class="cart-post_item">
            <el-checkbox :label="item.id" :key="item.id" class="no-show-label" style="line-height: 100%;width: 100%;">
              <society-orgn-card :orgn="item.orgn" :major-name="item.majorName" :extra-data="{ cartId: item.id }" style="width: 100%;display: inline-block;"></society-orgn-card>
            </el-checkbox>
          </div>
        </el-checkbox-group>

        <div v-if="isLogin && cartList.length > 0">
          <el-checkbox v-model="checkedAll" @change="checkAll">全选</el-checkbox>
        </div>

        <div class="no-data" v-if="isLogin && cartList.length === 0">
          <ghidri-empty>投递箱是空的</ghidri-empty>
          <div class="no-data-btn">
            <el-button type="primary" block icon="el-icon-top-left" plain round size="large" @click="toPostPage">去申请</el-button>
          </div>
        </div>

        <div class="no-data" v-if="!isLogin">
          <p style="text-align: center;color:lightgray;margin-bottom: 10px;">
            <i class="el-icon-user empty-icon"/>
            <br>
            <span>您还没有登录</span>
          </p>
          <div class="not-login-btn">
            <el-button type="info" block round @click="toLogin">立即登录</el-button>
          </div>
        </div>

        <div class="cart-block" v-if="isLogin && cartList.length > 0">
          <ghidri-button @click="remove" size="large" type="info" class="cart-button add-cart">删 除</ghidri-button>
          <ghidri-button @click="submit" size="large" class="cart-button apply">{{ submitBarText }}</ghidri-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import societyCartApi from "@/api/society/societyCart.js";
  import store from "@/store";

  import SocietyOrgnCard from "../orgn/card.vue"

  export default {
    name: "SocietyCart",
    components: {
      SocietyOrgnCard
    },
    data() {
      return {
        checkedCartItem: [],//当前选中的投递箱项目id
        allCartItem: [], // 用户所有的投递箱项目id列表
        cartList: [],//投递箱列表
        checkedAll: true,//全选
      };
    },
    created() {
      this.init();
    },
    computed: {
      submitBarText() {
        const count = this.checkedCartItem.length;
        return "申请" + (count ? `(${count})` : `(0)`);
      },
      isLogin() {//是否登录
        return store.getters.user;
      }
    },
    methods: {
      init() {
        const _this = this;
        societyCartApi.queryByUser().then(res => {
          if (res.success) {
            const list = res.data;
            for (const index in list) {
              _this.checkedCartItem.push(list[index].id);
            }

            _this.allCartItem = _this.checkedCartItem;//默认全选
            _this.cartList = list;
          }
        }).catch((err) => {
          _this.$message.warning(err || "网络出错，请稍后再试");
          _this.$router.push("/login");
        });
      },
      submit() {
        if (this.checkedCartItem.length === 0) {
          this.$message.warning("至少选择一项");
          return false;
        } else if (this.checkedCartItem.length > 3) {
          this.$message.warning("最多选择三项");
          return false;
        } else {
          this.$router.push({ path: "/society/checkout", query: { ids: this.checkedCartItem } });
        }
      },
      toPostPage() {
        this.$router.push('/society')
      },
      toLogin() {
        this.$router.push({
          path: 'login',
          query: {
            redirect: '/society/cart'
          }
        })
      },
      checkedCartChangeEvent(value) {
        if (value.length === this.allCartItem.length) {
          this.checkedAll = true
        } else {
          this.checkedAll = false
        }
      },
      checkAll() {
        const _this = this;
        if (_this.checkedAll === true) {
          _this.checkedCartItem = _this.allCartItem
        } else {
          _this.checkedCartItem = []
        }
      },
      remove() {
        const _this = this;
        if (_this.checkedCartItem.length === 0) {
          _this.$message.warning("至少选择一项");
          return false;
        } else {
          societyCartApi.remove(_this.checkedCartItem).then(res => {
            _this.checkedCartItem = []
            _this.init();
          }).catch(err => {
            console.log("err", err);
            _this.$message.warning(err || "网络出错，请稍后再试");
          });
        }
      },
      backEvent() {
        this.$router.go(-1);
      }
    }

  };
</script>

<style lang="less">
  .el-checkbox__label {
    width: 100%;
    height: auto;
    padding: 0 10px 0 15px;
    box-sizing: border-box;
  }
</style>

<style scoped lang="less">
  .cart-box {
    min-height: calc(100vh - 400px);
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }

  .cart {
    width: 900px;

    &_head {
      margin-bottom: 20px;

      .title {
        padding-bottom: 8px;
        font-weight: 700;
        font-size: 22px;
        border-bottom: 2px solid #3370ff;
        color: #3370ff;
        line-height: 100%;
      }
    }
  }

  .cart-post {
    width: 100%;
  }

  .cart-post_item {
    position: relative;

    .el-checkbox__label {
      width: 100%;
      height: auto;
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .el-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .el-card__price {
      color: #f44;
    }
  }

  .empty-icon {
    text-align: center;
    zoom: 300%;
  }

  .not-login-btn {
    text-align: center;
  }

  .cart-block {
    margin: auto;
    margin-top: 30px;
    line-height: 2em;
  }

  .cart-button {
    display: inline-flex;
    width: 200px;
  }

  .add-cart {
    float: left;
  }

  .apply {
    float: right;
  }

</style>
